export default __webpack_public_path__ + "static/media/mallalli_falls.05ea4ab3.jpg";